import React from 'react';

interface ReportContextType {
  report?: ReportType;
  isEditing?: boolean;
  currentScope: FilterPlateType[];
  currentDrillDowns: FilterPlateType[];
  reset: () => void;
  isExporting?: boolean;
  setIsExporting?: (bool: boolean) => void;
  gridExportCallbacks?: GridExportCallback[];
  setGridExportCallbacks?: React.Dispatch<
    React.SetStateAction<GridExportCallback[]>
  >;
  onAddVisualization?: () => void;
  onEditReportGadget?: (gadget: ReportGadgets.ReportGadget) => void;
  setCurrentCanvas?: React.Dispatch<React.SetStateAction<Canvas>>;
  setIsEditing?: React.Dispatch<React.SetStateAction<boolean>>;
  quickFilters: LegacySavedFilter[];
  selectedQuickFilters: LegacySavedFilter[];
  setSelectedQuickFilters: React.Dispatch<
    React.SetStateAction<LegacySavedFilter[]>
  >;
  // True when the report is being captured by the headless scheduled-report PDF
  // renderer. The canvas uses this to size gadget rows against a fixed reference
  // height rather than the (tall) capture viewport.
  isHeadlessRender?: boolean;
  // True ONLY under the scheduled-report PDF print route (PrintReportShow passes
  // forceHeadlessRender). Distinct from isHeadlessRender, which is ALSO true on
  // live wallboards and for any wallboard user on a normal report route. Used to
  // gate print-only behaviour (e.g. refitting grid cards to their content) so it
  // never affects interactive views or wallboards.
  isPdfExport?: boolean;
}
const ReportContext = React.createContext<ReportContextType>({
  currentScope: [],
  currentDrillDowns: [],
  reset: () => {},
  quickFilters: [],
  selectedQuickFilters: [],
  setSelectedQuickFilters: () => {},
} as ReportContextType);

export default ReportContext;
